import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./shared.css";
import "./Services.css";

function Services() {
  return (
    <main className="servicesPage">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Services & Approach | Radix Software Solutions</title>
        <meta
          name="description"
          content="Radix Software Solutions provides software consulting, integrations, reporting, and automation with a practical, senior-led approach."
        />
        <meta
          property="og:title"
          content="Services & Approach | Radix Software Solutions"
        />
        <meta
          property="og:description"
          content="Software consulting, integrations, reporting, and automation delivered by a practical, senior-led team."
        />
        <meta property="og:site_name" content="Radix Software Solutions" />
        <meta
          property="og:url"
          content="https://www.radixsoftwaresolutions.com/services"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Services & Approach | Radix Software Solutions"
        />
        <meta
          name="twitter:description"
          content="Software consulting, integrations, reporting, and automation delivered by a practical, senior-led team."
        />
        <link
          rel="canonical"
          href="https://www.radixsoftwaresolutions.com/services"
        />
      </Helmet>

      <section className="section servicesHero" id="services-hero">
        <div className="pageContainer">
          <p className="sectionKicker">Services & Approach</p>
          <h1 className="servicesTitle">
            Software Consulting & Reporting Solutions
          </h1>
          <p className="paragraphTextStyle servicesIntro">
            Radix helps teams connect systems, automate workflows, and deliver
            decision-ready reporting with pragmatic, maintainable solutions.
          </p>
          <Link className="ctaPrimary" to="/contact">
            Contact
          </Link>
        </div>
      </section>

      <section className="section" id="services">
        <div className="pageContainer">
          <div className="sectionHeader">
            <p className="sectionKicker">What we do</p>
            <h2 className="headerTextStyle">Services</h2>
            <p className="paragraphTextStyle sectionLead">
              Outcome-focused services designed to keep data clean, connected,
              and usable.
            </p>
          </div>
          <div className="grid servicesGrid">
            <article className="card serviceCard">
              <h3 className="cardTitle">Systems Integrations</h3>
              <p className="paragraphSnippetStyle serviceCopy">
                Connect SaaS, APIs, and databases so data moves reliably across
                your stack.
              </p>
            </article>
            <article className="card serviceCard">
              <h3 className="cardTitle">Data Pipelines & ETL</h3>
              <p className="paragraphSnippetStyle serviceCopy">
                Build stable pipelines that normalize, validate, and deliver the
                right data on schedule.
              </p>
            </article>
            <article className="card serviceCard">
              <h3 className="cardTitle">Reporting & Dashboards</h3>
              <p className="paragraphSnippetStyle serviceCopy">
                Executive-ready dashboards that surface the KPIs you need to run
                the business.
              </p>
            </article>
            <article className="card serviceCard">
              <h3 className="cardTitle">Business Process Automation</h3>
              <p className="paragraphSnippetStyle serviceCopy">
                Reduce manual work with automation that keeps teams aligned and
                accurate.
              </p>
            </article>
            <article className="card serviceCard">
              <h3 className="cardTitle">Technical Consulting</h3>
              <p className="paragraphSnippetStyle serviceCopy">
                Architecture guidance and execution support for critical systems
                and reporting needs.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="section" id="how-we-work">
        <div className="pageContainer">
          <div className="sectionHeader">
            <p className="sectionKicker">How we work</p>
            <h2 className="headerTextStyle">How we work</h2>
            <p className="paragraphTextStyle sectionLead">
              A clear, collaborative process focused on maintainability and
              business outcomes.
            </p>
          </div>
          <div className="grid workGrid">
            <article className="card workCard">
              <p className="workStep">01</p>
              <h3 className="cardTitle">Discover & define</h3>
              <p className="paragraphSnippetStyle workCopy">
                We clarify goals, constraints, and the data sources that matter
                most.
              </p>
            </article>
            <article className="card workCard">
              <p className="workStep">02</p>
              <h3 className="cardTitle">Design & implement</h3>
              <p className="paragraphSnippetStyle workCopy">
                We deliver pragmatic solutions that integrate cleanly and scale
                with you.
              </p>
            </article>
            <article className="card workCard">
              <p className="workStep">03</p>
              <h3 className="cardTitle">Deliver & support</h3>
              <p className="paragraphSnippetStyle workCopy">
                We document, train, and support so the work stays reliable long
                after launch.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="section aboutSection" id="about-radix">
        <div className="pageContainer">
          <div className="sectionHeader">
            <p className="sectionKicker">About Radix</p>
            <h2 className="headerTextStyle">About Radix</h2>
          </div>
          <div className="card aboutCard">
            <p className="paragraphTextStyle aboutCopy">
              Radix Software Solutions is a small, senior-led consultancy focused
              on practical, maintainable software. We specialize in integrations,
              data, automation, and reporting across SaaS and custom systems,
              delivering solutions that avoid bloat and keep teams in control.
            </p>
          </div>
        </div>
      </section>

      <section className="section ctaSection" id="cta">
        <div className="pageContainer ctaContainer">
          <div>
            <h2 className="ctaTitle">Let's work together</h2>
            <p className="paragraphTextStyle ctaCopy">
              Tell us about your reporting, integration, or automation goals.
            </p>
          </div>
          <Link className="ctaPrimary" to="/contact">
            Get in touch
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Services;
